import { Component, HostBinding, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Shared } from '@shared/exports';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [CommonModule, Shared],
  templateUrl: './accordion.html',
  styleUrl: './accordion.scss'
})
export class Accordion {
  // Inputs
  title = input.required<string>();
  icon = input<string>('');
  iconSize = input<string>('2.5rem');
  isOpen = input<boolean>(false);
  titleColor = input<string>('');
  customIconUrl = input<string>('');
  style = input<'classic' | 'new'>('classic');

  @HostBinding('class.style-new') get isNew() { return this.style() === 'new'; }

  // Outputs
  toggle = output<void>();

  onToggle(): void {
    this.toggle.emit();
  }
}
